import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { router } from "./routes/routes.jsx";
import store from "./redux/store.js";
import AppInitializer from "./components/AppInitializer.jsx";

function App() {
  return (
    <Provider store={store}>
      <AppInitializer>
        <RouterProvider router={router} />
      </AppInitializer>
    </Provider>
  );
}

export default App;
